import React from "react";
import { styled } from "@mui/system";
import MUISwitch, { SwitchProps } from "@mui/material/Switch";

export const Switch = styled((props: SwitchProps) => <MUISwitch {...props} />, {
  name: "Switch",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiSwitch-root	.MuiSwitch-switchBase": {
    padding: 13,
    "&:hover": {
      background: "transparent",
    },
  },
  "&.MuiSwitch-root.MuiSwitch-sizeSmall	.MuiSwitch-switchBase": {
    padding: 8,
  },
  "&.MuiSwitch-root .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
    color: theme.palette.primary.baseWhiteColor,
  },
  "&.MuiSwitch-root .MuiSwitch-track": {
    background: theme.palette.primary.neutral50Color,
    borderRadius: 8,
    opacity: "unset",
    width: 30,
    height: 16,
  },
  "&.MuiSwitch-root .Mui-checked+.MuiSwitch-track": {
    background: theme.palette.primary.baseVaporGradient,
    opacity: "unset",
  },
  "&.MuiSwitch-root .Mui-checked": {
    color: theme.palette.primary.baseWhiteColor,
    padding: 13,
    paddingLeft: 7,
  },
  "&.MuiSwitch-root .MuiSwitch-switchBase.MuiSwitch-colorError.Mui-checked+.MuiSwitch-track":
    {
      background: theme.palette.primary.borderError,
    },
  "&.MuiSwitch-root .MuiSwitch-switchBase.MuiSwitch-colorWarning.Mui-checked+.MuiSwitch-track":
    {
      background: theme.palette.primary.baseWarningColor,
    },
  "&.MuiSwitch-root.MuiSwitch-sizeSmall .Mui-checked": {
    color: theme.palette.primary.baseWhiteColor,
    padding: 8,
    paddingLeft: 2,
  },
  "&.MuiSwitch-root .Mui-disabled.MuiChecked+ .MuiSwitch-track": {
    background: theme.palette.primary.interactiveDisabledColor,
    color: theme.palette.primary.baseWhiteColor,
    opacity: "unset",
  },
  "&.MuiSwitch-root .Mui-disabled+ .MuiSwitch-track": {
    background: theme.palette.primary.interactiveDisabledColor,
    color: theme.palette.primary.baseWhiteColor,
    opacity: "unset",
  },
  "&.MuiSwitch-root .MuiSwitch-switchBase .MuiSwitch-thumb": {
    width: 14,
    height: 14,
    color: theme.palette.primary.baseWhiteColor,
    ".Mui-checked": {
      background: theme.palette.primary.baseVaporGradient,
    },
  },
}));
